import React from 'react';
import {IonNav} from '@ionic/react';

import InfoScreen from '../screens/InfoScreen';

function Tab3() {
    return <IonNav root={() => <InfoScreen/>}></IonNav>;
}

export default Tab3;